import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
    selector: 'app-live-incident-banner',
    templateUrl: './live-incident-banner.component.html',
    styleUrls: ['./live-incident-banner.component.scss'],
    standalone: false
})
export class LiveIncidentBannerComponent {
    @Input() banner: any = null;
    @Output() bannerClick = new EventEmitter<void>();
}
